module.exports = __webpack_public_path__ + "static/img/right-door-wall-steel_256.6f4f237.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right-door-wall-steel_256.png
// module id = TZj9
// module chunks = 0